
import { getDaysRemaining } from '@/utils/dateUtils';

export interface RentalInfo {
  id: string;
  bikeId: string;
  bikeModel?: string;
  startDate: string;
  endDate?: string;
  status: 'active' | 'completed' | 'cancelled' | 'pending';
  amount: number;
  daysLeft?: number;
  human_number?: string;
  documentsUrl?: string;
  subscription_id?: string; // Добавляем поле для связи с подпиской
}

export interface CourierRentalsResponse {
  rentals: RentalInfo[];
  currentRental: RentalInfo | null;
  loading: boolean;
  error: string | null;
}

export function formatRental(rental: any): RentalInfo {
  const daysLeft = rental.end_date ? getDaysRemaining(rental.end_date) : undefined;
  
  return {
    id: rental.id,
    bikeId: rental.bike_id,
    bikeModel: rental.bikes?.model || 'Неизвестная модель',
    startDate: rental.start_date,
    endDate: rental.end_date,
    status: (rental.status || 'active') as 'active' | 'completed' | 'cancelled' | 'pending',
    amount: rental.amount || 0,
    daysLeft,
    human_number: rental.human_number,
    documentsUrl: rental.documents_url,
    subscription_id: rental.subscription_id
  };
}
